import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'precision'
})
export class PrecisionCheckPipe implements PipeTransform {
  transform(value: number, precision: number) {
    if (typeof(value) === 'number') {
      const zero = 0;
      if (Math.abs(value) < Math.pow(10, -precision)) {
        return zero.toFixed(precision);
      }
        return value.toFixed(precision);
    }
    return value;
}
}
